import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import TextField from "@components/forms/TextField/TextField";
import Button from "@components/forms/Button/Button";
import UserService from "@services/UserService";
import "./ForgotPasswordPage.scss";

function ForgotPasswordPage() {
    const [isFetching, setFetching] = useState<boolean>(false);
    const [email, setEmail] = useState<string>('');

    const { t } = useTranslation();
    const navigate = useNavigate();

    const service = new UserService;

    const handleSubmit = (e: React.FormEvent|null) => {
        if(e !== null) {
            e.preventDefault();
        }

        const forgotPassword = service.forgotPassword(email);
        setFetching(true);

        toast.promise(forgotPassword, {
            loading: t('toast.forgot_password_sending_link'),
            success: data => t('toast.forgot_password_link_sent'),
            error: err => err.body && err.body.message || t('toast.error_fetching'),
        }, {
            duration: 5000,
        });

        forgotPassword.then(data => {
            setTimeout(() => {
                setFetching(false);
            }, 10000);
        }).catch(() => {
            setFetching(false);
        });
    };

    const handleLogin = () => {
        navigate('/');
    };

    return (
        <div className="p-3">
            <div className="login-container">
                <h1>🔑 {t('title.forgot_password')}</h1>

                    <form onSubmit={handleSubmit}>
                        <div className="row gy-3">
                            <div className="col-12">
                                <TextField style="secondary" label={t('page.login.input.email.label')} value={email} placeholder={t('page.login.input.email.placeholder')} onChange={setEmail}/>
                            </div>

                            <div className="col-12">
                                <Button filled onClick={() => handleSubmit(null)} disabled={isFetching || email === ''}>{t('page.forgot_password.btn_send_link')}</Button>
                            </div>

                            <div className="col-12 text-center">
                                {t('text.or')}
                            </div>

                            <div className="col-12">
                                <Button filled className="secondary" onClick={handleLogin} disabled={isFetching}>{t('page.signup.input.login')}</Button>
                            </div>
                        </div>
                    </form>
                </div>
        </div>
    );
}

export default ForgotPasswordPage;
